import { useStation } from '../../../core/stations/hooks/useStation';
import { FragmentTagGroup } from '@app/core/types/stations';

export function useFragmentTagGroups(stationId: string): FragmentTagGroup[] {
  const station = useStation(stationId);

  return station.featuresConfig?.fragments?.tagGroups || [];
}
